var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "0 20px" } },
    [
      _c(
        "div",
        { staticClass: "closeCurrntPage", on: { click: _vm.closeCurrntPage } },
        [_vm._v("X关闭当前页")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "head" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: {
                click: function($event) {
                  return _vm.oneKeyEnter(false)
                }
              }
            },
            [
              _c("span", { staticStyle: { "font-size": "12px" } }, [
                _vm._v("一键录入打包数")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: {
                click: function($event) {
                  return _vm.oneKeyClear(false)
                }
              }
            },
            [
              _c("span", { staticStyle: { "font-size": "12px" } }, [
                _vm._v("一键清空打包数")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: {
                background: "#409eff",
                "border-color": "#409eff",
                float: "right"
              },
              attrs: { size: "mini" },
              on: { click: _vm.resetBoxNum }
            },
            [
              _c(
                "span",
                { staticStyle: { "font-size": "12px", color: "#fff" } },
                [_vm._v("刷新")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          attrs: {
            data: _vm.tableData,
            "row-class-name": _vm.tableRowClassName,
            border: ""
          }
        },
        [
          _c("el-table-column", { attrs: { type: "index", label: "序号" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "created_at", label: "推送日期" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "main_number", label: "主订单号" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "serial_number", label: "编号" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.serial_number
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.serial_number
                                .split("-")
                                .slice(3)
                                .join("-")
                            )
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "weight", label: "总重量(kg)", width: "140px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.can_change
                      ? _c("el-input", {
                          attrs: {
                            disabled:
                              scope.row.isEditStatus && scope.row.can_change,
                            placeholder: "",
                            size: "mini"
                          },
                          on: {
                            focus: function(val) {
                              _vm.focusWeight(val, scope.row)
                            },
                            change: function(val) {
                              _vm.changeCurrentWeight(
                                val,
                                scope.row,
                                scope.$index
                              )
                            }
                          },
                          model: {
                            value: scope.row.weight,
                            callback: function($$v) {
                              _vm.$set(scope.row, "weight", $$v)
                            },
                            expression: "scope.row.weight"
                          }
                        })
                      : _c("el-input", {
                          attrs: {
                            disabled: true,
                            placeholder: "",
                            size: "mini"
                          },
                          model: {
                            value: scope.row.weight,
                            callback: function($$v) {
                              _vm.$set(scope.row, "weight", $$v)
                            },
                            expression: "scope.row.weight"
                          }
                        })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "ruigu_code", label: "打包数", width: "140px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.can_change
                      ? _c("el-input", {
                          attrs: {
                            disabled:
                              scope.row.isEditStatus && scope.row.can_change,
                            placeholder: "",
                            size: "mini"
                          },
                          on: {
                            change: function(val) {
                              _vm.changeCurrentBoxNum(
                                val,
                                scope.row,
                                scope.$index
                              )
                            }
                          },
                          model: {
                            value: scope.row.boxNumCopy,
                            callback: function($$v) {
                              _vm.$set(scope.row, "boxNumCopy", $$v)
                            },
                            expression: "scope.row.boxNumCopy"
                          }
                        })
                      : _c("el-input", {
                          attrs: {
                            disabled: true,
                            placeholder: "",
                            size: "mini"
                          },
                          model: {
                            value: scope.row.boxNumCopy,
                            callback: function($$v) {
                              _vm.$set(scope.row, "boxNumCopy", $$v)
                            },
                            expression: "scope.row.boxNumCopy"
                          }
                        })
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div", { staticClass: "select-total-wrap" }, [
        _c("div", [_vm._v("合计")]),
        _vm._v(" "),
        _c("div", [
          _vm._v("主订单数量: "),
          _c("span", [_vm._v(_vm._s(_vm.tableDataTotal.mainTotal))])
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v("总重量(kg): "),
          _c("span", [_vm._v(_vm._s(_vm.tableDataTotal.weight))])
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v("打包数: "),
          _c("span", [_vm._v(_vm._s(_vm.tableDataTotal.boxNum))])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "save" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: {
                click: function($event) {
                  return _vm.saveBoxNum(false)
                }
              }
            },
            [
              _c("span", { staticStyle: { "font-size": "12px" } }, [
                _vm._v("保存")
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "append-to-body": true,
            center: "",
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "span",
            {
              staticStyle: { color: "#fff" },
              attrs: { slot: "title" },
              slot: "title"
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.currentDialogType === _vm.dialogType[3]
                      ? "提示"
                      : "确认"
                  ) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _vm.currentDialogType === _vm.dialogType[0]
            ? _c("div", { staticClass: "dialog-item" }, [
                _c("p", { staticClass: "title content" }, [_vm._v("一键录入")]),
                _vm._v(" "),
                _c("p", { staticClass: "content gap-bottom" }, [
                  _vm._v("(打包数统一设置为1)")
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("p", { staticClass: "content" }, [
                    _vm._v("\n          注意：\n        ")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "content" }, [
                    _vm._v(
                      "\n          1.若已有打包数，该原有数据不会被录入\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "content" }, [
                    _vm._v(
                      "\n          2.若打包数非1，一键录入后可手工修改\n        "
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currentDialogType === _vm.dialogType[1]
            ? _c("div", { staticClass: "dialog-item" }, [
                _c("p", { staticClass: "title content" }, [_vm._v("一键清空")]),
                _vm._v(" "),
                _c("p", { staticClass: "content gap-bottom" }, [
                  _vm._v("("),
                  _c("span", { staticClass: "red-color" }, [
                    _vm._v("打包数、重量、箱码")
                  ]),
                  _vm._v("统一清空)")
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("p", { staticClass: "content" }, [
                    _vm._v("\n          注意：\n        ")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "content" }, [
                    _vm._v(
                      "\n          1.一键清空后,可再次一键录入或者手工设置\n        "
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currentDialogType === _vm.dialogType[2]
            ? _c("div", { staticClass: "dialog-item" }, [
                _c("p", { staticClass: "title content" }, [
                  _c("span", { staticClass: "red-color" }, [
                    _vm._v("订单打包数，是否均为1")
                  ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("p", { staticClass: "content" }, [
                    _vm._v(
                      "\n          若不是，请手工修改打包数再保存，或者退出该页面后通过订单“编辑”修改打包数\n        "
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currentDialogType === _vm.dialogType[3]
            ? _c(
                "div",
                [
                  _vm._l(_vm.failedData, function(item) {
                    return _c("p", { key: item.id, staticClass: "content" }, [
                      _c("span", { staticStyle: { color: "#555" } }, [
                        _vm._v("主订单号")
                      ]),
                      _c(
                        "span",
                        {
                          staticStyle: { "font-weight": "600", color: "#555" }
                        },
                        [_vm._v(_vm._s(item.main_number) + "：")]
                      ),
                      _c("span", { staticClass: "red-color" }, [
                        _vm._v(_vm._s(item.msg))
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("删除多余箱码，请到订单“编辑”操作")])
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentDialogType !== _vm.dialogType[3]
            ? _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.dialogVisible = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.dialogConfirm }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed10d388", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed10d388","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bigorder/quick-set-box-num.vue
// module id = null
// module chunks = 